import React, { FC } from 'react';
import Anchor from 'components/Anchor';
import Box from 'components/Box';

import logo from 'assets/images/onfleet-logo-dark.png';
// Unused in version 1, but it is going to be used in a future version
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Image, LogOut } from './styles';
import cookies from 'browser-cookies';

const Logo: FC = () => {
  /**
   * Method to handle the logout button which removes the trak_auth cookie.
   * Unused in version 1, but it is going to be used in a future version.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const logout = (): void => {
    const logoutCookie = {
      stage: 'trak_auth_s',
      prod: 'trak_auth_p',
      development: 'trak_auth_d',
    }[import.meta.env.VITE_ENVIRONMENT_NAME || 'development'] || 'trak_auth_d';

    cookies.erase(logoutCookie);
  };

  if (import.meta.env.VITE_AUTH_COOKIE_VALUE) {
    cookies.set('trak_auth_s', import.meta.env.VITE_AUTH_COOKIE_VALUE);
    cookies.set('trak_auth_d', import.meta.env.VITE_AUTH_COOKIE_VALUE);
  }

  return (
    <Anchor to="/">
      <Box flex={true} direction="row" align="center">
        <Image
          onClick={() => window.open(`${import.meta.env.VITE_ONFLEET_URL}dashboard#/manage`)}
          src={logo}
          alt="Logo"
          sizes="small"
        />
        {/*
         * Unused in version 1, but it is going to be used in a future version
         * <LogOut primary label="LogOut" size="small" onClick={() => logout()}></LogOut>
         */}
      </Box>
    </Anchor>
  );
};

export default Logo;
